mutation DeleteQueuesMutation($names: [String!]!) {
  deleteQueues(names: $names) {
    id
    name
  }
}
